// Email Signup Modal functionality
document.addEventListener("DOMContentLoaded", function () {
  const modal = document.querySelector("#email-signup-modal");
  const trigger = document.querySelector(".email-signup-trigger");
  const closeButton = document.querySelector("#ModalClose-email-signup");

  if (!modal || !trigger) {
    console.log("Modal or trigger not found");
    return;
  }

  // Open modal when trigger is clicked
  trigger.addEventListener("click", function (e) {
    e.preventDefault();
    modal.setAttribute("open", "");
    document.body.style.overflow = "hidden";

    // Focus on the first input field
    const firstInput = modal.querySelector('input[type="text"]');
    if (firstInput) {
      setTimeout(() => firstInput.focus(), 100);
    }
  });

  // Close modal when close button is clicked
  if (closeButton) {
    closeButton.addEventListener("click", function () {
      modal.removeAttribute("open");
      document.body.style.overflow = "";
    });
  }

  // Close modal when clicking outside
  modal.addEventListener("click", function (e) {
    if (e.target === modal) {
      modal.removeAttribute("open");
      document.body.style.overflow = "";
    }
  });

  // Close modal with Escape key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && modal.hasAttribute("open")) {
      modal.removeAttribute("open");
      document.body.style.overflow = "";
    }
  });
});
